<div class="message" *ngFor="let message of messages">
  <div class="title">{{ message.title }}</div>
  <div class="text">{{ message.text }}</div>
</div>
